import styled from 'styled-components';
import { SIDEBAR_MOBILE_BREAKPOINT } from '@constants/sidebar';

/**
 * Top-level page shell — full-height column with the sticky TopBar at the top
 * and a scrolling body filling the remainder. Mirrors the prototype's
 * `.listpage--home-header` (padding: 0; flex column; min-height: 0).
 */
export const PageRoot = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  background: ${({ theme: { colors = {} } }) => colors.surface ?? '#0E0F18'};
`;

/**
 * Single scrolling region. Contains the toolbar AND the list — they scroll
 * together (the prototype does the same: `.listpage__body` is the scroller
 * and `.listpage__bar` lives inside it). Padding of `32px 28px` matches
 * the prototype's `--space-7 / 28px` exactly.
 */
export const PageBody = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: 32px 28px;

  @media (max-width: ${SIDEBAR_MOBILE_BREAKPOINT}px) {
    padding: 16px 12px;
  }
`;
